import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-popup-cancel-dialog',
  templateUrl: './popup-cancel-dialog.component.html',
  styleUrls: ['./popup-cancel-dialog.component.scss']
})
export class PopupCancelDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
